module.exports = __webpack_public_path__ + "img/card3.0dc423f1.png";